
  <mat-toolbar>{{"Select User To Add" | translate | async}}</mat-toolbar>
  <div class="DialogBoxCL">
<div class="SelectUser">

  <!--<h4>User</h4>-->  
<!-- 
  <mat-form-field class="MFF">
    <mat-label>User_</mat-label>
    <input type="text" matInput (input)="changeModelAutoComplete($event)"  [matAutocomplete]="auto">
    <mat-autocomplete  [(ngModel)]="selectedUserId" #model_auto="ngModel" #auto="matAutocomplete" >    
      <mat-option *ngFor="let option of UserList" [value]="option.userID">
        {{option.userName}}
      </mat-option> 
  </mat-autocomplete>
  </mat-form-field> -->

  
  <!-- <mat-form-field class="MFF">
    <mat-label>Job Site</mat-label>
     <mat-select (selectionChange)="jobsiteChanged($event)" [(ngModel)]="selectedSiteId">
      <mat-option *ngFor="let option of jobsitebyCustomerID" [value]="option.crsf_auto" (click)="onChangeCustomer(option)">
        {{option.site_name}}
      </mat-option>
    </mat-select>
  </mat-form-field> -->


  <mat-form-field  class="search-input MFF">
    <input type="text" [placeholder]="'User' | translate | async" (input)="changeModelAutoComplete($event)"   matInput  [matAutocomplete]="auto">
    <mat-autocomplete [(ngModel)]="selectedUserId" #model_auto="ngModel"  #auto="matAutocomplete" [displayWith]="getTitle.bind(this)" (optionSelected)="modelselect($event.option.value)" ngDefaultControl  >
      <mat-option *ngFor="let option of UserList" [value]="option.UserId">
        {{option.FullName}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
<!--<span>userId {{userid}} userName {{usename}} </span>-->
  <div class="DialogBoxCLBtn">
    <button mat-stroked-button class="AddNewUserClAddBtn" (click)="AddNewUser()">{{"Add" | translate | async}}</button>
    <button mat-stroked-button class="AddNewUserClClsBtn" (click)="DialogClose()">{{"Close" | translate | async}}</button>
  </div>

</div>
